<template>
<m-pageframe
    :title="title"
>
<v-container v-if="settings != null">

    <h2>General</h2>

    <m-edit-text
        label="Label"
        v-model="settings.label"
        v-on:input="patchSettings"
        hint="Internal only - Not visible to customers."
        :read_only='!can_write'
    />

    <m-edit-text
        label="Settings Id"
        :value="settings.settings_id"
        read_only
    />

    <m-edit-text
        label="Is Default"
        :value="settings.is_default ? 'Yes' : 'No'"
        read_only
    />

    <m-edit-text
        label="Bubble Text"
        v-model="settings.bubble_text"
        v-on:input="patchSettings"
        :read_only='!can_write'
    />

    <m-edit-text
        label="Bubble Scale Mobile (%)"
        v-model="settings.bubble_scale_mobile"
        v-on:input="patchSettings"
        :read_only='!can_write'
        integer_positive_non_zero
    />

    <m-edit-text
        label="Bubble Delay (milliseconds -- 1,000 ms = 1 sec)"
        v-model="settings.bubble_delay"
        v-on:input="patchSettings"
        :read_only='!can_write'
        integer_positive_non_zero
    />

    <m-edit-text
        label="Bubble Scale Desktop (%)"
        v-model="settings.bubble_scale_desktop"
        v-on:input="patchSettings"
        :read_only='!can_write'
        integer_positive_non_zero
    />

    <v-select
        label="Position"
        v-model="settings.position"
        :items="$rc.enumChoices('widget_position',false)"
        v-on:change="patchSettings"
        :disabled="!can_write"
    />

    <v-row>

        <v-col>
            <m-edit-text
                label="Shift X"
                v-model="settings.position_shift_x"
                v-on:input="patchSettings"
                integer
                :read_only='!can_write'
            />
        </v-col>

        <v-col>
            <m-edit-text
                label="Shift Y"
                v-model="settings.position_shift_y"
                v-on:input="patchSettings"
                integer
                :read_only='!can_write'
            />
        </v-col>

        <v-col>
            <m-edit-text
                label="Widget Z Index"
                v-model="settings.iframe_z_index"
                v-on:input="patchSettings"
                integer_positive
                :read_only='!can_write'
            />
        </v-col>

    </v-row>

    
    <v-row>
        <v-col
            style="max-width: 300px"
        >
            <v-switch
                label="Show Bubble (Desktop)"
                v-model="settings.bubble_show_desktop"
                v-on:change="patchSettings"
                :disabled="!can_write"
            />
        </v-col>
        <v-col>
            <v-switch
                label="Show Bubble (Mobile)"
                v-model="settings.bubble_show_mobile"
                v-on:change="patchSettings"
                :disabled="!can_write"
            />
        </v-col>
    </v-row>

    <v-switch
        label="Users must select an inbox (if multiple inboxes are showing)"
        v-model="settings.require_select_inbox"
        v-on:change="patchSettings"
        :disabled="!can_write"
    />

    <m-edit-text
        label="Title"
        v-model="settings.title"
        v-on:input="patchSettings"
        :read_only='!can_write'
    />

    <m-edit-text
        label="Form Intro Text"
        v-model="settings.form_intro_text"
        v-on:input="patchSettings"
        :read_only='!can_write'
    />

    <m-edit-textarea
        label="Thank You Message"
        v-model="settings.message_text_thank_you"
        v-on:input="patchSettings"
        :read_only='!can_write'
    />

    <h2>Field Options</h2>

    <v-select
        label="Email"
        v-model="settings.field_options_email"
        :items="std_field_options"
        v-on:change="patchSettings"
        :disabled="!can_write"
    />

    <v-row>
        <v-col
            style="max-width: 250px"
        >
            <v-select
                label="Zip Code"
                v-model="settings.field_options_zip"
                :items="std_field_options"
                v-on:change="patchSettings"
                :disabled="!can_write"
            />
        </v-col>
        <v-col>
            <m-edit-text
                label="Zip Code Label"
                v-model="settings.field_options_zip_label"
                v-on:input="patchSettings"
                :disabled="!can_write"
            />
        </v-col>
    </v-row>
    

    <v-alert
        type="info"
        v-if="settings.us_alcohol_can_not_edit_age_age"
    >
        Your organization is in the wine industry. Industry guidelines recommend collecting birthday (MM/DD/YYYY format)
        when consumers opt in to texting. You can customize the age gate settings below.
    </v-alert>


    <v-select
        label="Age Gate"
        v-model="settings.age_gate_type"
        :items="age_gate_type"
        v-on:change="patchSettings"
        :disabled="!can_write"
    />

    <m-edit-text
        label="Minimum Age (years)"
        v-model="settings.age_gate_min_age_in_years"
        v-on:input="patchSettings"
        integer_positive_non_zero
        v-if="settings.age_gate_type != 'none'"
        :read_only='!can_write'
    />

    
    

    <h2>Avatars</h2>

    
    <div
        style="display: inline-block; margin: 15px; text-align: center; padding: 15px; border: 1px solid rgba(0,0,0,0.2); border-radius: 10px;"
        v-for="(url, index) in settings.avatar_image_urls"
        :key="index"
    >
        <img
            :src="url"
            style="width: 150px; border-radius: 50%;"
        />
        <br/>

        <v-icon
            style="margin-top: 7px; margin-bottom: 7px;"
            v-on:click="onClickDeleteAvatar(index)"
        >
            mdi-trash-can-outline
        </v-icon>
        
    </div>

    <br/>

    <div 
        style="text-align: right; margin-top: 15px; margin-bottom: 15px;"
    >
        <v-btn
            style="margin-right: 15px;"
            v-on:click="onClickRemoveDefaultAvatars"
            :disabled="!can_write"
        >
            Remove Default Avatars
        </v-btn>

         <v-btn
            style="margin-right: 15px;"
            v-on:click="onClickRestoreDefaultAvatars"
            :disabled="!can_write"
        >
            Restore Default Avatars
        </v-btn>


        <v-btn 
            class="mx-2" fab dark small color="primary"
            v-on:click="onClickAddAvatar"
            :disabled="!can_write"
        >
            <v-icon dark>mdi-plus</v-icon>
        </v-btn>
    </div>

    <m-widget-settings-upload-avatar-confirm-dialog
        ref="upload-avatar-confirm-dialog"
    />

    <m-edit-blobs-dialog
        ref="upload-blob-dialog"
        title="Upload Avatars"
        v-on:ok="afterUploadAvatars($event)"
        :externally_visible="true"
        :show_send_as_links="false"
        :organization_id="settings.organization_id"
    />
      
    <h2>Colors</h2>

    <m-edit-color-line
       label="Primary Color"
       v-model="settings.color_primary"
       default_color="#5D647C"
       v-on:input="patchSettings"
       :read_only="!can_write"
    />

    

    <m-edit-color-line
       label="Text on Primary Color"
       v-model="settings.color_on_primary_text"
       default_color="#FFFFFF"
       v-on:input="patchSettings"
       :read_only="!can_write"
    />

    <m-edit-color-line
       label="Secondary Color"
       v-model="settings.color_secondary"
       default_color="#7F8AAC"
       v-on:input="patchSettings"
       :read_only="!can_write"
    />

    <m-edit-color-line
       label="Form Background Color"
       v-model="settings.color_form_bkg"
       default_color="#F5F5F5"
       v-on:input="patchSettings"
       :read_only="!can_write"
    />

    <m-edit-color-line
       label="Business Message Bubble Color"
       v-model="settings.color_biz_bubble"
       default_color="#E4E4F0"
       v-on:input="patchSettings"
       :read_only="!can_write"
    />

    <m-edit-color-line
       label="Customer Message Bubble Color"
       v-model="settings.color_customer_bubble"
       default_color="#FFFFFF"
       v-on:input="patchSettings"
       :read_only="!can_write"
    />

    <m-edit-color-line
       label="Pop Up Bubble Background Color"
       v-model="settings.color_bubble_bkg"
       default_color="#FFFFFF"
       v-on:input="patchSettings"
       :read_only="!can_write"
    />

    <m-edit-color-line
       label="Pop Up Bubble Border Color"
       v-model="settings.color_bubble_border"
       default_color="#7F8AAC"
       v-on:input="patchSettings"
       :read_only="!can_write"
    />

     <m-edit-color-line
       label="Pop Up Bubble Text Color"
       v-model="settings.color_bubble_text"
       default_color="#000000"
       v-on:input="patchSettings"
       :read_only="!can_write"
    />

   

    <m-edit-color-line
       label="Activator Background Color"
       v-model="settings.color_activator_bkg"
       default_color="#5D647C"
       v-on:input="patchSettings"
       :read_only="!can_write"
    />

    <m-edit-color-line
       label="Activator Active Background Color"
       v-model="settings.color_activator_bkg_active"
       default_color="#7F8AAC"
       v-on:input="patchSettings"
       :read_only="!can_write"
    />

    <m-edit-color-line
       label="Activator Icon Color"
       v-model="settings.color_activator_icon"
       default_color="#FFFFFF"
       v-on:input="patchSettings"
       :read_only="!can_write"
    />

    <p>
        Need help with color codes?  Take a look at <a href="https://htmlcolorcodes.com/color-picker/" target="_blank">HTML Color Codes</a>
    </p>

    <div
        style="margin-bottom: 15px"
        v-show="!show_advanced_style_controls"
    >
        <a v-on:click="show_advanced_style_controls = true;">Show advanced style options</a>
    </div>

    <div
        v-show="show_advanced_style_controls"
    >

        <m-edit-textarea
            label="Custom CSS (Advanced)"
            v-model="settings.custom_css"
            v-on:input="patchSettings"
            optional
        />

        <m-edit-color-line
            label="Pop Up Bubble Close Button Foreground Color"
            v-model="settings.color_bubble_close"
            default_color="#7F8AAC"
            v-on:input="patchSettings"
            :read_only="!can_write"
            
            optional
            :unset_value="settings.color_bubble_border"
        />

        <m-edit-color-line
            label="Pop Up Bubble Close Button Background Color"
            v-model="settings.color_bubble_close_bkg"
            default_color="#FFFFFF"
            v-on:input="patchSettings"
            :read_only="!can_write"
            
            optional
            :unset_value="settings.color_customer_bubble"
        />
    </div>


    <div
        v-show="false"
    >
        <!-- This section is not longer shown because web replaced our dependenace on Google Analytics with our build in Webchat analytics --> 
        <!-- RedChirp google analytics support is for GA3, GA4 has a completely different event model that we do not support --> 
        
        <h2>Google Analytics</h2>

        <m-edit-text
            label="Tracking ID"
            v-model="settings.ga_tracking_id"
            v-on:input="patchSettings"
            hint="Unique ID used to track events for your account. (Starts with UA-...)"
            :read_only='!can_write'
            :optional="true"
        />

        <v-expansion-panels>
            <v-expansion-panel>
                <v-expansion-panel-header>
                    Bubble Shown Event
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <m-edit-text
                        label="Event Category"
                        v-model="settings.ga_bubble_shown_category"
                        v-on:input="patchSettings"
                        hint="Category for the Opened Bubble Event (default RedChirp WebChat)"
                        :read_only='!can_write'
                    />

                    <m-edit-text
                        label="Event Action"
                        v-model="settings.ga_bubble_shown_action"
                        v-on:input="patchSettings"
                        hint="Action event name (default web_chat_shown)"
                        :read_only='!can_write'
                    />

                    <m-edit-text
                        label="Event Label"
                        v-model="settings.ga_bubble_shown_label"
                        v-on:input="patchSettings"
                        hint="Label for event (default Opened Bubble)"
                        :read_only='!can_write'
                    />
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>

        <v-expansion-panels>
            <v-expansion-panel>
                <v-expansion-panel-header>
                    Opened Bubble Event
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <m-edit-text
                        label="Event Category"
                        v-model="settings.ga_opened_bubble_category"
                        v-on:input="patchSettings"
                        hint="Category for the Opened Bubble Event (default RedChirp WebChat)"
                        :read_only='!can_write'
                    />

                    <m-edit-text
                        label="Event Action"
                        v-model="settings.ga_opened_bubble_action"
                        v-on:input="patchSettings"
                        hint="Action event name (default opened_bubble)"
                        :read_only='!can_write'
                    />

                    <m-edit-text
                        label="Event Label"
                        v-model="settings.ga_opened_bubble_label"
                        v-on:input="patchSettings"
                        hint="Label for event (default Opened Bubble)"
                        :read_only='!can_write'
                    />
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>

        <v-expansion-panels>
            <v-expansion-panel>
                <v-expansion-panel-header>
                    WebChat Submitted Event
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <m-edit-text
                        label="Event Category"
                        v-model="settings.ga_submitted_category"
                        v-on:input="patchSettings"
                        hint="Category for the WebChat Submitted (default RedChirp WebChat)"
                        :read_only='!can_write'
                    />

                    <m-edit-text
                        label="Event Action"
                        v-model="settings.ga_submitted_action"
                        v-on:input="patchSettings"
                        hint="Action event name (default web_chat_submitted)"
                        :read_only='!can_write'
                    />

                    <m-edit-text
                        label="Event Label"
                        v-model="settings.ga_submitted_label"
                        v-on:input="patchSettings"
                        hint="Label for event (default WebChat Submitted)"
                        :read_only='!can_write'
                    />
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>

        <v-expansion-panels
            style="padding-bottom: 10px"
        >
            <v-expansion-panel>
                <v-expansion-panel-header>
                    WebChat Abandoned Event
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <m-edit-text
                        label="Event Category"
                        v-model="settings.ga_abandoned_category"
                        v-on:input="patchSettings"
                        hint="Category for the WebChat Abandoned (default RedChirp WebChat)"
                        :read_only='!can_write'
                    />

                    <m-edit-text
                        label="Event Action"
                        v-model="settings.ga_abandoned_action"
                        v-on:input="patchSettings"
                        hint="Action event name (default web_chat_abandoned)"
                        :read_only='!can_write'
                    />

                    <m-edit-text
                        label="Event Label"
                        v-model="settings.ga_abandoned_label"
                        v-on:input="patchSettings"
                        hint="Label for event (default WebChat Abandoned)"
                        :read_only='!can_write'
                    />
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>
    </div>

    <h2>On Site Schedule</h2>
    <m-daily-schedule
        v-model="settings.on_site_schedule"
        :read_only="false"
        v-on:input="patchSettings"
    />

    <div
        style="text-align: center"
    >
        <v-btn
            dense
            v-on:click="onResetOnSiteSchedule"
        >
            Reset to 24/7 On site schedule...
        </v-btn>
    </div>

    <h2>Consent Agreement(s)</h2>

    <m-select-consent-agreement
        label="Widget Submission Agreement"
        v-model="settings.consent_agreement_id_submission"
        :choices="settings.consent_agreement_submission_choices"
        v-on:input="patchSettings"
        style="margin-bottom: 25px;"
    />

    <div
        style="text-align: right"
    >
        <v-btn
            v-on:click="onClickEditAgreements"
        >
        Create / Edit Agreement(s)...
        </v-btn>
    </div>

     <m-select-consent-agreement
        label="Check Box Agreement"
        v-model="settings.consent_agreement_id_check_box"
        :choices="settings.consent_agreement_check_box_choices"
        v-on:input="patchSettings"
        allow_none
        style="margin-bottom: 30px;"
    />

    <h2>Technical</h2>

    <v-checkbox
        label="Disable Location Watching"
        v-model="settings.technical_disable_iframe_location_watch"
        v-on:change="patchSettings"
    />

    <h2>Test These Widget Settings</h2>

    <m-test-widget
        :organization_id="settings.organization_id"
        :settings_id="settings.settings_id"
    />

</v-container>
</m-pageframe>
</template>


<script>
const default_avatars = ["https://files.redchirp.com/widget-avatar-1.jpg","https://files.redchirp.com/widget-avatar-2.jpg","https://files.redchirp.com/widget-avatar-3.jpg","https://files.redchirp.com/widget-avatar-4.jpg","https://files.redchirp.com/widget-avatar-5.jpg","https://files.redchirp.com/widget-avatar-6.jpg","https://files.redchirp.com/widget-avatar-7.jpg","https://files.redchirp.com/widget-avatar-8.jpg","https://files.redchirp.com/widget-avatar-9.jpg","https://files.redchirp.com/widget-avatar-10.jpg"];

export default {
    data() {
        return {
            settings: null,

            std_field_options: [
                    {'text' : 'Do not request', 'value' : 'do-not-request'},
                    {'text' : 'Optional', 'value' : 'request-optional'},
                    {'text' : 'Required', 'value' : 'request-required'}
                ],
            age_gate_type: [
                    {'text' : 'None', 'value' : 'none'},
                    {'text' : 'Yes/no selection', 'value' : 'checkbox'},
                    {'text' : 'Enter birth date', 'value' : 'birthdate'}
                ],

            show_advanced_style_controls: false,
            
        }
    },

    mounted () {
        this.reloadSettings();
    },

    methods: {
        reloadSettings() 
        {
            let settings_id = this.$route.params.settings_id;
            
            this.$rc.showSpinner();
            
            this.$rc.getWidgetSettings(
                settings_id,
            
                (data) => {
                    this.$rc.hideSpinner();

                    this.settings = data;
                },
            
                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to complete API call');
                },
            );
        },

        onClickEditAgreements()
        {
            this.$router.push({
                'name': 'settings-custom-consent-agreements',
                'params' : {
                    'organization_id': this.settings.organization_id,
                }
            });
        },

        onResetOnSiteSchedule()
        {
            this.settings.on_site_schedule = {
                "monday_intervals" : [ "All Day" ],
                "tuesday_intervals" : [ "All Day" ],
                "wednesday_intervals" : [ "All Day" ],
                "thursday_intervals" : [ "All Day" ],
                "friday_intervals" : [ "All Day" ],
                "saturday_intervals" : [ "All Day" ],
                "sunday_intervals" : [ "All Day" ],
                "custom_intervals" : [ ]
            };

            this.patchSettings();
        },

        patchSettings()
        {
            this.$rc.showSpinner();

            
            this.$rc.patchWidgetSettings(
                this.settings,
            
                (data) => {
                    this.$rc.hideSpinner();

                    this.settings = data.after_patch;
                },
            
                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to edit widget settings.');
                },
            );
        },

        onClickDeleteAvatar(index)
        {
            if ( !this.can_write )
                return;

            this.$rc.confirm(
                'Delete Avatar',
                'Permenantly delete this avatar?',
                [
                    {'text': 'Cancel', 'value': 'cancel'},
                    {'text': 'Delete', 'value': 'confirm'},
                ],

                (response) => {
                    if (response != 'confirm') return;
                    
                    this.settings.avatar_image_urls.splice(index, 1);

                    this.patchSettings();
                }

            );
        },

        onClickAddAvatar()
        {
            this.$refs['upload-avatar-confirm-dialog'].showDialog(this.onAcceptTermsOfAvatarUpload);   
        },

        onAcceptTermsOfAvatarUpload()
        {
            this.$refs['upload-blob-dialog'].showDialog([],true);
        },

        afterUploadAvatars(blob_ids)
        {
            this.$rc.showSpinner();
            
            this.$rc.getBlobMetaDataMultiple(
                blob_ids,
            
                (data) => {
                    this.$rc.hideSpinner();

                    for ( let i = 0; i < data.meta_data.length; i++ )
                    {
                        let img = new Image();
                            img.onload = () => {
                                let width = img.width;
                                let height = img.height;

                                if ( Math.abs(width-height) / height < 0.05 )
                                {
                                    this.settings.avatar_image_urls.push(img.src);
                                    this.patchSettings();
                                }
                                else
                                {
                                    this.$rc.alert('Error', 'Unable to add avatar: image is not square');
                                }
                            }

                        img.src = 'https://files.redchirp.com/'+data.meta_data[i].object_name;
                    }
                },
            
                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to add image avatars');
                },
            );
        },

        onClickRestoreDefaultAvatars()
        {
            for ( let i = 0; i < default_avatars.length; i++ )
            {
                let avatar = default_avatars[i];

                if ( !this.settings.avatar_image_urls.includes(avatar) )
                {
                    this.settings.avatar_image_urls.push(avatar);
                }
            }

            this.patchSettings();
        },

        onClickRemoveDefaultAvatars()
        {
            for ( let i = this.settings.avatar_image_urls.length-1; i >= 0; i-- )
            {
                let cur_url = this.settings.avatar_image_urls[i];

                if ( default_avatars.includes(cur_url) )
                    this.settings.avatar_image_urls.splice(i,1);
            }
            
            this.patchSettings();
        }
    },

    computed: {
        title() {
            if ( this.settings == null )
                return 'Widget Settings';

            return 'Widget Settings: '+this.settings.label;
        },

        can_write() {
            return this.$rc.$state.isOrganizationAdmin() || this.$rc.$state.isSystemAdmin();
        }
    },
}
</script>

<style lang="scss" scoped>
</style>